/**
 * Idioma escolhido em Conta > Preferências (decisão 195): depois da abertura, busca a escolha
 * guardada no servidor e aplica, se for diferente da deste navegador. Sem rota no ar ou sem
 * escolha, nada muda (vale o idioma da marca).
 */
import { useEffect, useRef } from 'react';
import i18n from '../../i18n';
import { fetchPreferences } from '../../api/watchdog';
import { applyLanguage, isPanelLanguage } from '../../lib/panelLanguage';
import { useSessionStore } from '../../stores/sessionStore';

/** Deixa a sessão no mesmo idioma do painel (busca de palavras e captura usam). */
export function syncSessionLanguage(language: string): void {
  useSessionStore.setState((state) =>
    state.session ? { session: { ...state.session, language } } : state,
  );
}

export function usePanelLanguage(ready: boolean): void {
  const done = useRef(false);
  useEffect(() => {
    if (!ready || done.current) return;
    done.current = true;
    void fetchPreferences().then((result) => {
      if (!result.ok) return;
      const language = result.data.language;
      if (!isPanelLanguage(language)) return;
      syncSessionLanguage(language);
      if ((i18n.language ?? '').slice(0, 2) !== language) void applyLanguage(language);
    });
  }, [ready]);
}
